import { render } from "./HeaderComponent.vue?vue&type=template&id=3a850469&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=3a850469&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a850469"

export default script